import { render, staticRenderFns } from "./buttonPermission.vue?vue&type=template&id=6ebd1d9a&scoped=true&"
import script from "./buttonPermission.vue?vue&type=script&lang=js&"
export * from "./buttonPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd1d9a",
  null
  
)

export default component.exports